<div class="section">
  <mat-progress-spinner *ngIf="isLoading"></mat-progress-spinner>
  <br />
  <p *ngIf="!isLoading">Si è pregati di chiudere la pagina.</p>
</div>
